import CompanyDebugModal from "@/components/company/company-debug-modal";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useCompanyEnrichment } from "@/hooks/useCompanyEnrichment";
import {
  enrichmentLevelLabels,
  enrichmentLevelVariants,
} from "@/utils/enrichment";
import { CompanyDTO } from "@shaarp/common";
import { CircleCheckIcon, Loader2Icon, SparklesIcon } from "lucide-react";
import { useState } from "react";
import { Badge } from "../ui/badge";

export function DataTableCellCompanyEnrichment({
  company,
}: {
  company: CompanyDTO;
}) {
  const [open, setOpen] = useState(false);
  const { isEnriching, latestData } = useCompanyEnrichment(company.id);

  const effectiveLevel = latestData?.enrichmentLevel ?? company.enrichmentLevel;
  const isComplete = effectiveLevel >= 4;
  const showSpinner = isEnriching && !isComplete;

  let icon: React.ReactNode;
  if (showSpinner) {
    icon = <Loader2Icon className="w-4 h-4 animate-spin text-muted-foreground" />;
  } else if (isComplete) {
    icon = <CircleCheckIcon className="w-4 h-4 text-success" />;
  } else {
    icon = <SparklesIcon className="w-4 h-4 text-muted-foreground" />;
  }

  return (
    <div className="flex items-center gap-1.5">
      {icon}
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Badge
              variant={enrichmentLevelVariants[effectiveLevel]}
              className="cursor-pointer whitespace-nowrap"
              onClick={() => setOpen(true)}
            >
              {effectiveLevel}
            </Badge>
          </TooltipTrigger>
          <TooltipContent side="top">
            {enrichmentLevelLabels[effectiveLevel]}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      {company.isNewlyCreated && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Badge variant="default" className="text-[10px] px-1.5 py-0">
                N
              </Badge>
            </TooltipTrigger>
            <TooltipContent side="top">
              Newly created company from this search
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}

      <CompanyDebugModal
        company={company}
        open={open}
        onOpenChange={setOpen}
      />
    </div>
  );
}
